<div [class.padded]="padded" class="box">
  <h1 *ngIf="title" class="headline-3">{{ title }}</h1>
  <div *ngIf="showChat"><ng-container *ngTemplateOutlet="chatTemplate"></ng-container></div>
  <div *ngIf="!showChat"><ng-container *ngTemplateOutlet="mailTemplate"></ng-container></div>
</div>
<div *ngIf="showChat" [class.padded]="padded" class="box">
  <ng-container *ngTemplateOutlet="mailTemplate"></ng-container>
</div>
<div [class.padded]="padded" class="box">
  <h2 class="headline-4">{{ 'CONTACT_OVERLAY.MEETING.TITLE' | translate }}</h2>
  <p class="body-4 description">
    {{ 'CONTACT_OVERLAY.MEETING.DESCRIPTION' | translate }}
  </p>
  <button (click)="scheduleMeeting()" class="contact-button" data-analytics="contact-overlay_meeting">
    <dap-lib-icon iconColor="white" iconSize="16" name="calendar"></dap-lib-icon>
    {{ 'CONTACT_OVERLAY.MEETING.SCHEDULE' | translate }}
  </button>
</div>
<div [class.padded]="padded" class="box">
  <h2 class="headline-4">{{ 'CONTACT_OVERLAY.PHONE.TITLE' | translate }}</h2>
  <p class="body-4 description">
    {{ 'CONTACT_OVERLAY.PHONE.DESCRIPTION' | translate }}
  </p>
  <div *ngIf="'CONTACT_OVERLAY.PHONE.NUMBER' | translate as number" class="phone">
    <a [href]="'tel:' + number" class="contact-button" data-analytics="contact-overlay_phone">
      <dap-lib-icon iconColor="white" iconSize="16" name="phone"> </dap-lib-icon>
      {{ number }}
    </a>
    <span [innerHtml]="'CONTACT_OVERLAY.PHONE.HOURS' | translate" class="body-5 hours"></span>
  </div>
</div>

<ng-template #chatTemplate>
  <h2 class="headline-4">{{ 'CONTACT_OVERLAY.CHAT.TITLE' | translate }}</h2>
  <p class="body-4 description">
    {{ 'CONTACT_OVERLAY.CHAT.DESCRIPTION' | translate }}
  </p>
  <div class="phone">
    <button type="button" id="custom-launcher" class="contact-button" (click)="toggleMessenger()">
      <dap-lib-icon iconColor="white" iconSize="16" name="support"></dap-lib-icon>
      {{ 'CONTACT_OVERLAY.CHAT.CHAT' | translate }}
    </button>
    <span [innerHtml]="'CONTACT_OVERLAY.CHAT.HOURS' | translate" class="body-5 hours"></span>
  </div>
</ng-template>
<ng-template #mailTemplate>
  <h2 class="headline-4">{{ 'CONTACT_OVERLAY.MAIL.TITLE' | translate }}</h2>
  <p class="body-4 description">
    {{ 'CONTACT_OVERLAY.MAIL.DESCRIPTION' | translate }}
  </p>
  <button (click)="createMessage()" class="contact-button" data-analytics="contact-overlay_mail">
    <dap-lib-icon iconColor="white" iconSize="16" name="mail"></dap-lib-icon>
    {{ 'CONTACT_OVERLAY.MAIL.WRITE_US' | translate }}
  </button>
</ng-template>
